import {useMediaQuery} from "@material-ui/core";

export function useCurrentResolution(predefinedResolution) {
    const resolutions = [
        {
            id: 'mobile',
            result: useMediaQuery('(max-width:576px)')
        },
        {
            id: 'tablet',
            result: useMediaQuery('(max-width:768px)')
        },
        {
            id: 'desktop',
            result: useMediaQuery('(max-width:1024px)')
        },
    ]
    const currentRes = resolutions.filter(r => r.result === true)
    return predefinedResolution ? predefinedResolution : currentRes.length ? currentRes[0].id : 'desktop';
}